import { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { useOktaAuth, LoginCallback } from "@okta/okta-react";
import MainApp from "./MainApp";


const CustomError = ({ error }) => (
  <div>
    <h1>Authentication Error</h1>
    <p>{error?.message || "An error occurred during login. Please try again." }</p>
  </div>
);

export default function App() {
  const { authState, oktaAuth } = useOktaAuth();
  const location = useLocation();
  const isOnLoginCallback = location.pathname === "/login/callback";
  const [userInfo, setUserInfo] = useState(null);

  console.log("App.js: Current authState: ", authState);
  console.log("App.js Current path : ", location.pathname);

  useEffect(() => {

    if(!authState) {
      console.log("App.js : No authState, waiting for initialization");
      return;
    }

    if(authState.isPending) {
      console.log("App.js : authState is pending");
      return;
    }

    if ( !authState.isAuthenticated && !isOnLoginCallback ) {
      
      console.log("App.js : Not authenticated, redirecting to Okta!");
      oktaAuth.signInWithRedirect().catch( err => {
        console.error("App.js : Sign in redirect error : ", err.message);
        
      });
    }

    if (isOnLoginCallback && authState?.isAuthenticated && !userInfo) {
      const params = new URLSearchParams(location.search);
      const code = params.get("code");
      const state = params.get("state");
      console.log("App.js : Callback params - code : ", code, "state : ", state);

      if(code) {
        oktaAuth.token
          .exchangeCodeForTokens( {code} )
          .then( ({ tokens }) => {
            console.log("App.js : Tokens received : ", tokens);
            oktaAuth.tokenManager.setTokens(tokens);
            oktaAuth.authStateManager.updateAuthState();
          })
          .catch( err => {
            console.log("App.js : Token exchange error : ", err.message);
          });
      } else {
        console.error("No authentication code found in callback URL");
      }

    }

    if (authState.isAuthenticated) {
      console.log("Fetching user info...");

      oktaAuth.getUser().then(info => {

        //FOR DEMO: MOCK ROLES (Will remove once i get okta admin access back)
        //const demoRoles = ["ai_hr_access", "ai_product_access", "ai_admin", "ai_support_access", "ai_confluence_access", "ai_general_access", "ai_roleprofile_access" ];
        const demoRoles = ["ai_hr_access", "ai_product_access", "ai_admin", "ai_support_access", "ai_confluence_access", "ai_roleprofile_access", "ai_arcci_access"];

        const existingRoles = JSON.parse(localStorage.getItem("userRoles") || "[]");
        const rolesToUse = existingRoles.length ? existingRoles : [ "ai_hr_access" ];
        //const enriched = { ...info, roles: demoRoles }
        const enriched = { ...info, roles: rolesToUse }

        //setUserInfo(info);
        //localStorage.setItem("userInfo", JSON.stringify(info)); // Optional
        localStorage.setItem("userInfo", JSON.stringify(enriched)); 
        //localStorage.setItem("userRoles", JSON.stringify(demoRoles));
        localStorage.setItem("userRoles", JSON.stringify(rolesToUse)); 
        setUserInfo(enriched);

        console.log("User info:", info);
        console.log("User info:", enriched);
      }).catch(err => {
        console.error("Failed to get user info:", err);
      });
    }

    
  }, [authState, oktaAuth, isOnLoginCallback, location ]);

  //if (!authState) {
  //  console.log("App.js : Rendering loading due to no authState");
  //  return <div>Loading authentication1...</div>;
  //}

  //if(error) {
  //  return <div>Authentication Error: {error}</div>
  //}


  return (
    <Routes>
      <Route 
        path="/login/callback" 
        element={ 
          <LoginCallback
            errorComponent = {CustomError}
            loadingElement = {<div>Processing Login...</div>}
          />
        } 
      />
      <Route 
        path="/*" 
        element = {
          authState?.isPending ? 
            ( <div>Loading authentication2..... </div> )
          :
            authState?.isAuthenticated ?
              ( <MainApp userInfo={userInfo} /> )
            :
              ( <div>Redirecting to login.... </div> )
        } 
      />
    </Routes>
  );
}